import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=4d5a8bc8&"
import script from "./CompanySetting.vue?vue&type=script&lang=ts&"
export * from "./CompanySetting.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports